import React from "react";
import Breadcrumb from "../Components/Breadcrumb";
import Category from "../Components/Category/CategoryPage";
import { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

function Categoryscreen() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    AOS.init({
      once: false,
    });

    const handleScroll = () => {
      AOS.refresh();
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <>
      <Category />
    </>
  );
}

export default Categoryscreen;
